// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-gallery-icon {
  color: #fff;
  transition: all 0.3s ease-out;
  -webkit-appearance: none;
          appearance: none;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
  cursor: pointer;
  outline: none;
  position: absolute;
  z-index: 4;
  filter: drop-shadow(0 2px 2px rgb(25.5, 25.5, 25.5));
}

@media (hover: hover) and (pointer: fine) {
  .image-gallery-icon:hover {
    color: #337ab7;
  }
  .image-gallery-icon:hover .image-gallery-svg {
    transform: scale(1.1);
  }
}
.image-gallery-icon:focus {
  outline: 2px solid #337ab7;
}

.image-gallery-using-mouse .image-gallery-icon:focus {
  outline: none;
}

.image-gallery-fullscreen-button, .image-gallery-play-button {
  bottom: 0;
  padding: 20px;
}

.image-gallery-fullscreen-button .image-gallery-svg, .image-gallery-play-button .image-gallery-svg {
  height: 28px;
  width: 28px;
}

@media (max-width: 768px) {
  .image-gallery-fullscreen-button, .image-gallery-play-button {
    padding: 15px;
  }
  .image-gallery-fullscreen-button .image-gallery-svg, .image-gallery-play-button .image-gallery-svg {
    height: 24px;
    width: 24px;
  }
}
@media (max-width: 480px) {
  .image-gallery-fullscreen-button, .image-gallery-play-button {
    padding: 10px;
  }
  .image-gallery-fullscreen-button .image-gallery-svg, .image-gallery-play-button .image-gallery-svg {
    height: 16px;
    width: 16px;
  }
}
.image-gallery-fullscreen-button {
  right: 0;
}

.image-gallery-play-button {
  left: 0;
}

.image-gallery-top-nav, .image-gallery-bottom-nav {
  padding: 10px 10px;
  left: 50%;
  transform: translateX(-50%);
}

.image-gallery-top-nav .image-gallery-svg, .image-gallery-bottom-nav .image-gallery-svg {
  height: 120px;
  width: 90px;
}

@media (max-width: 768px) {
  .image-gallery-top-nav .image-gallery-svg, .image-gallery-bottom-nav .image-gallery-svg {
    height: 72px;
    width: 48px;
  }
}
@media (max-width: 480px) {
  .image-gallery-top-nav .image-gallery-svg, .image-gallery-bottom-nav .image-gallery-svg {
    height: 48px;
    width: 36px;
  }
}
.image-gallery-top-nav[disabled], .image-gallery-bottom-nav[disabled] {
  cursor: disabled;
  opacity: 0.6;
  pointer-events: none;
}

.image-gallery-top-nav {
  top: 0;
}

.image-gallery-bottom-nav {
  bottom: 0;
}

.image-gallery-left-nav, .image-gallery-right-nav {
  padding: 50px 10px;
  top: 50%;
  transform: translateY(-50%);
}

.image-gallery-left-nav .image-gallery-svg, .image-gallery-right-nav .image-gallery-svg {
  height: 120px;
  width: 60px;
}

@media (max-width: 768px) {
  .image-gallery-left-nav .image-gallery-svg, .image-gallery-right-nav .image-gallery-svg {
    height: 72px;
    width: 36px;
  }
}
@media (max-width: 480px) {
  .image-gallery-left-nav .image-gallery-svg, .image-gallery-right-nav .image-gallery-svg {
    height: 48px;
    width: 24px;
  }
}
.image-gallery-left-nav[disabled], .image-gallery-right-nav[disabled] {
  cursor: disabled;
  opacity: 0.6;
  pointer-events: none;
}

.image-gallery-left-nav {
  left: 0;
}

.image-gallery-right-nav {
  right: 0;
}

.image-gallery {
  -webkit-user-select: none;
  -o-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  position: relative;
}

.image-gallery.fullscreen-modal {
  background: #000;
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 5;
}

.image-gallery.fullscreen-modal .image-gallery-content {
  top: 50%;
  transform: translateY(-50%);
}

.image-gallery-content {
  position: relative;
  line-height: 0;
  top: 0;
}

.image-gallery-content.fullscreen {
  background: #000;
}

.image-gallery-content .image-gallery-slide .image-gallery-image {
  max-height: calc(100vh - 80px);
}

.image-gallery-content.image-gallery-thumbnails-left .image-gallery-slide .image-gallery-image, .image-gallery-content.image-gallery-thumbnails-right .image-gallery-slide .image-gallery-image {
  max-height: 100vh;
}

.image-gallery-slide-wrapper {
  position: relative;
}

.image-gallery-slide-wrapper.image-gallery-thumbnails-left, .image-gallery-slide-wrapper.image-gallery-thumbnails-right {
  display: inline-block;
  width: calc(100% - 110px);
}

@media (max-width: 768px) {
  .image-gallery-slide-wrapper.image-gallery-thumbnails-left, .image-gallery-slide-wrapper.image-gallery-thumbnails-right {
    width: calc(100% - 87px);
  }
}
.image-gallery-slide-wrapper.image-gallery-rtl {
  direction: rtl;
}

.image-gallery-slides {
  line-height: 0;
  overflow: hidden;
  position: relative;
  white-space: nowrap;
  text-align: center;
  touch-action: none;
}

.image-gallery-slide {
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.image-gallery-slide.image-gallery-center {
  position: relative;
}

.image-gallery-slide .image-gallery-image {
  width: 100%;
  object-fit: contain;
}

.image-gallery-slide .image-gallery-description {
  background: rgba(0, 0, 0, 0.4);
  bottom: 70px;
  color: #fff;
  left: 0;
  line-height: 1;
  padding: 10px 20px;
  position: absolute;
  white-space: normal;
}

@media (max-width: 768px) {
  .image-gallery-slide .image-gallery-description {
    bottom: 45px;
    font-size: 0.8em;
    padding: 8px 15px;
  }
}
.image-gallery-bullets {
  bottom: 20px;
  left: 0;
  margin: 0 auto;
  position: absolute;
  right: 0;
  width: 80%;
  z-index: 4;
}

.image-gallery-bullets .image-gallery-bullets-container {
  margin: 0;
  padding: 0;
  text-align: center;
}

.image-gallery-bullets .image-gallery-bullet {
  -webkit-appearance: none;
          appearance: none;
  background-color: rgba(0, 0, 0, 0);
  border: 1px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 2px hsl(0, 0%, 10%);
  cursor: pointer;
  display: inline-block;
  margin: 0 5px;
  outline: none;
  padding: 5px;
  transition: all 0.2s ease-out;
}

@media (max-width: 768px) {
  .image-gallery-bullets .image-gallery-bullet {
    margin: 0 3px;
    padding: 3px;
  }
}
@media (max-width: 480px) {
  .image-gallery-bullets .image-gallery-bullet {
    padding: 2.7px;
  }
}
.image-gallery-bullets .image-gallery-bullet:focus {
  transform: scale(1.2);
  background: #337ab7;
  border: 1px solid #337ab7;
}

.image-gallery-bullets .image-gallery-bullet.active {
  transform: scale(1.2);
  border: 1px solid #fff;
  background: #fff;
}

@media (hover: hover) and (pointer: fine) {
  .image-gallery-bullets .image-gallery-bullet:hover {
    background: #337ab7;
    border: 1px solid #337ab7;
  }
  .image-gallery-bullets .image-gallery-bullet.active:hover {
    background: #337ab7;
  }
}
.image-gallery-bullets.image-gallery-bullets-vertical {
  left: 20px;
  right: auto;
  bottom: auto;
  width: auto;
  top: 50%;
  transform: translateY(-50%);
}

.image-gallery-bullets.image-gallery-bullets-vertical .image-gallery-bullet {
  display: block;
  margin: 12px 0;
}

@media (max-width: 768px) {
  .image-gallery-bullets.image-gallery-bullets-vertical .image-gallery-bullet {
    margin: 6px 0px;
    padding: 3px;
  }
}
@media (max-width: 480px) {
  .image-gallery-bullets.image-gallery-bullets-vertical .image-gallery-bullet {
    padding: 2.7px;
  }
}
.image-gallery-thumbnails-wrapper {
  position: relative;
}

.image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal {
  touch-action: pan-y;
}

.image-gallery-thumbnails-wrapper.thumbnails-swipe-vertical {
  touch-action: pan-x;
}

.image-gallery-thumbnails-wrapper.thumbnails-wrapper-rtl {
  direction: rtl;
}

.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
  display: inline-block;
  vertical-align: top;
  width: 100px;
}

@media (max-width: 768px) {
  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
    width: 81px;
  }
}
.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails {
  height: 100%;
  width: 100%;
  left: 0;
  padding: 0;
  position: absolute;
  top: 0;
}

.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail {
  display: block;
  margin-right: 0;
  padding: 0;
}

.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 0;
  margin-top: 2px;
}

.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
  margin: 0 5px;
}

@media (max-width: 768px) {
  .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left, .image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right {
    margin: 0 3px;
  }
}
.image-gallery-thumbnails {
  overflow: hidden;
  padding: 5px 0;
}

@media (max-width: 768px) {
  .image-gallery-thumbnails {
    padding: 3px 0;
  }
}
.image-gallery-thumbnails .image-gallery-thumbnails-container {
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
}

.image-gallery-thumbnail {
  display: inline-block;
  border: 4px solid rgba(0, 0, 0, 0);
  transition: border 0.3s ease-out;
  width: 100px;
  background: rgba(0, 0, 0, 0);
  padding: 0;
}

@media (max-width: 768px) {
  .image-gallery-thumbnail {
    border: 3px solid rgba(0, 0, 0, 0);
    width: 81px;
  }
}
.image-gallery-thumbnail + .image-gallery-thumbnail {
  margin-left: 2px;
}

.image-gallery-thumbnail .image-gallery-thumbnail-inner {
  display: block;
  position: relative;
}

.image-gallery-thumbnail .image-gallery-thumbnail-image {
  vertical-align: middle;
  width: 100%;
  line-height: 0;
}

.image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
  outline: none;
  border: 4px solid #337ab7;
}

@media (max-width: 768px) {
  .image-gallery-thumbnail.active, .image-gallery-thumbnail:focus {
    border: 3px solid #337ab7;
  }
}
@media (hover: hover) and (pointer: fine) {
  .image-gallery-thumbnail:hover {
    outline: none;
    border: 4px solid #337ab7;
  }
}
@media (hover: hover) and (pointer: fine) and (max-width: 768px) {
  .image-gallery-thumbnail:hover {
    border: 3px solid #337ab7;
  }
}
.image-gallery-thumbnail-label {
  box-sizing: border-box;
  color: #fff;
  font-size: 1em;
  left: 0;
  line-height: 1em;
  padding: 5%;
  position: absolute;
  top: 50%;
  text-shadow: 0 2px 2px hsl(0, 0%, 10%);
  transform: translateY(-50%);
  white-space: normal;
  width: 100%;
}

@media (max-width: 768px) {
  .image-gallery-thumbnail-label {
    font-size: 0.8em;
    line-height: 0.8em;
  }
}
.image-gallery-index {
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  line-height: 1;
  padding: 10px 20px;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 4;
}

@media (max-width: 768px) {
  .image-gallery-index {
    font-size: 0.8em;
    padding: 5px 10px;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/react-image-gallery/styles/css/image-gallery.css"],"names":[],"mappings":"AAAA;EAAoB,WAAA;EAAW,6BAAA;EAA4B,wBAAA;UAAA,gBAAA;EAAgB,kCAAA;EAA+B,SAAA;EAAS,eAAA;EAAe,aAAA;EAAa,kBAAA;EAAkB,UAAA;EAAU,oDAAA;AAW3K;;AAX+N;EAAwC;IAA0B,cAAA;EAgB/R;EAhB6S;IAA6C,qBAAA;EAmB1V;AACF;AApBkX;EAA0B,0BAAA;AAuB5Y;;AAvBsa;EAAqD,aAAA;AA2B3d;;AA3Bwe;EAA4D,SAAA;EAAS,aAAA;AAgC7iB;;AAhC0jB;EAAkG,YAAA;EAAY,WAAA;AAqCxqB;;AArCmrB;EAAyB;IAA4D,aAAA;EA0CtwB;EA1CmxB;IAAkG,YAAA;IAAY,WAAA;EA8Cj4B;AACF;AA/C+4B;EAAyB;IAA4D,aAAA;EAmDl+B;EAnD++B;IAAkG,YAAA;IAAY,WAAA;EAuD7lC;AACF;AAxD2mC;EAAiC,QAAA;AA2D5oC;;AA3DopC;EAA2B,OAAA;AA+D/qC;;AA/DsrC;EAAiD,kBAAA;EAAkB,SAAA;EAAS,2BAAA;AAqElwC;;AArE6xC;EAAuF,aAAA;EAAa,WAAA;AA0Ej4C;;AA1E44C;EAAyB;IAAuF,YAAA;IAAY,WAAA;EAgFtgD;AACF;AAjFohD;EAAyB;IAAuF,YAAA;IAAY,WAAA;EAsF9oD;AACF;AAvF4pD;EAAqE,gBAAA;EAAgB,YAAA;EAAW,oBAAA;AA4F5vD;;AA5FgxD;EAAuB,MAAA;AAgGvyD;;AAhG6yD;EAA0B,SAAA;AAoGv0D;;AApGg1D;EAAiD,kBAAA;EAAkB,QAAA;EAAQ,2BAAA;AA0G35D;;AA1Gs7D;EAAuF,aAAA;EAAa,WAAA;AA+G1hE;;AA/GqiE;EAAyB;IAAuF,YAAA;IAAY,WAAA;EAqH/pE;AACF;AAtH6qE;EAAyB;IAAuF,YAAA;IAAY,WAAA;EA2HvyE;AACF;AA5HqzE;EAAqE,gBAAA;EAAgB,YAAA;EAAW,oBAAA;AAiIr5E;;AAjIy6E;EAAwB,OAAA;AAqIj8E;;AArIw8E;EAAyB,QAAA;AAyIj+E;;AAzIy+E;EAAe,yBAAA;EAAoE,oBAAA;EAAoB,iBAAA;EAAiB,6CAAA;EAA0C,kBAAA;AAmJ3oF;;AAnJ6pF;EAAgC,gBAAA;EAAgB,SAAA;EAAS,YAAA;EAAY,OAAA;EAAO,eAAA;EAAe,QAAA;EAAQ,MAAA;EAAM,WAAA;EAAW,UAAA;AA+JjxF;;AA/J2xF;EAAuD,QAAA;EAAQ,2BAAA;AAoK11F;;AApKq3F;EAAuB,kBAAA;EAAkB,cAAA;EAAc,MAAA;AA0K56F;;AA1Kk7F;EAAkC,gBAAA;AA8Kp9F;;AA9Ko+F;EAAiE,8BAAA;AAkLriG;;AAlLmkG;EAA+L,iBAAA;AAsLlwG;;AAtLmxG;EAA6B,kBAAA;AA0LhzG;;AA1Lk0G;EAAuH,qBAAA;EAAqB,yBAAA;AA+L98G;;AA/Lu+G;EAAyB;IAAuH,wBAAA;EAoMrnH;AACF;AArMgpH;EAA+C,cAAA;AAwM/rH;;AAxM6sH;EAAsB,cAAA;EAAc,gBAAA;EAAgB,kBAAA;EAAkB,mBAAA;EAAmB,kBAAA;EAAkB,kBAAA;AAiNxzH;;AAjN00H;EAAqB,OAAA;EAAO,kBAAA;EAAkB,MAAA;EAAM,WAAA;AAwN93H;;AAxNy4H;EAA0C,kBAAA;AA4Nn7H;;AA5Nq8H;EAA0C,WAAA;EAAW,mBAAA;AAiO1/H;;AAjO6gI;EAAgD,8BAAA;EAA0B,YAAA;EAAY,WAAA;EAAW,OAAA;EAAO,cAAA;EAAc,kBAAA;EAAkB,kBAAA;EAAkB,mBAAA;AA4OvqI;;AA5O0rI;EAAyB;IAAgD,YAAA;IAAY,gBAAA;IAAe,iBAAA;EAmP5xI;AACF;AApPgzI;EAAuB,YAAA;EAAY,OAAA;EAAO,cAAA;EAAc,kBAAA;EAAkB,QAAA;EAAQ,UAAA;EAAU,UAAA;AA6P54I;;AA7Ps5I;EAAwD,SAAA;EAAS,UAAA;EAAU,kBAAA;AAmQj+I;;AAnQm/I;EAA6C,wBAAA;UAAA,gBAAA;EAAgB,kCAAA;EAA+B,sBAAA;EAAsB,kBAAA;EAAkB,qCAAA;EAAmC,eAAA;EAAe,qBAAA;EAAqB,aAAA;EAAa,aAAA;EAAa,YAAA;EAAY,6BAAA;AAiRpuJ;;AAjRgwJ;EAAyB;IAA6C,aAAA;IAAa,YAAA;EAuRj1J;AACF;AAxRg2J;EAAyB;IAA6C,cAAA;EA4Rp6J;AACF;AA7Rq7J;EAAmD,qBAAA;EAAqB,mBAAA;EAAmB,yBAAA;AAkShhK;;AAlSyiK;EAAoD,qBAAA;EAAqB,sBAAA;EAAsB,gBAAA;AAwSxoK;;AAxSwpK;EAAwC;IAAmD,mBAAA;IAAmB,yBAAA;EA8SpwK;EA9S6xK;IAA0D,mBAAA;EAiTv1K;AACF;AAlT62K;EAAsD,UAAA;EAAU,WAAA;EAAW,YAAA;EAAY,WAAA;EAAW,QAAA;EAAQ,2BAAA;AA0Tv9K;;AA1Tk/K;EAA4E,cAAA;EAAc,cAAA;AA+T5kL;;AA/T0lL;EAAyB;IAA4E,eAAA;IAAe,YAAA;EAqU5sL;AACF;AAtU2tL;EAAyB;IAA4E,cAAA;EA0U9zL;AACF;AA3U+0L;EAAkC,kBAAA;AA8Uj3L;;AA9Um4L;EAA8D,mBAAA;AAkVj8L;;AAlVo9L;EAA4D,mBAAA;AAsVhhM;;AAtVmiM;EAAyD,cAAA;AA0V5lM;;AA1V0mM;EAAiI,qBAAA;EAAqB,mBAAA;EAAmB,YAAA;AAgWnxM;;AAhW+xM;EAAyB;IAAiI,WAAA;EAqWv7M;AACF;AAtWq8M;EAAqL,YAAA;EAAY,WAAA;EAAW,OAAA;EAAO,UAAA;EAAU,kBAAA;EAAkB,MAAA;AA8WprN;;AA9W0rN;EAAuO,cAAA;EAAc,eAAA;EAAe,UAAA;AAoX97N;;AApXw8N;EAAyR,cAAA;EAAc,eAAA;AAyX/uO;;AAzX8vO;EAAiI,aAAA;AA6X/3O;;AA7X44O;EAAyB;IAAiI,aAAA;EAkYpiP;AACF;AAnYojP;EAA0B,gBAAA;EAAgB,cAAA;AAuY9lP;;AAvY4mP;EAAyB;IAA0B,cAAA;EA4Y7pP;AACF;AA7Y8qP;EAA8D,eAAA;EAAe,kBAAA;EAAkB,mBAAA;AAkZ7wP;;AAlZgyP;EAAyB,qBAAA;EAAqB,kCAAA;EAA+B,gCAAA;EAA+B,YAAA;EAAY,4BAAA;EAAyB,UAAA;AA2Zj7P;;AA3Z27P;EAAyB;IAAyB,kCAAA;IAA+B,WAAA;EAia1gQ;AACF;AAlawhQ;EAAkD,gBAAA;AAqa1kQ;;AAra0lQ;EAAwD,cAAA;EAAc,kBAAA;AA0ahqQ;;AA1akrQ;EAAwD,sBAAA;EAAsB,WAAA;EAAW,cAAA;AAgb3wQ;;AAhbyxQ;EAA+D,aAAA;EAAa,yBAAA;AAqbr2Q;;AArb83Q;EAAyB;IAA+D,yBAAA;EA0bp9Q;AACF;AA3bg/Q;EAAwC;IAA+B,aAAA;IAAa,yBAAA;EAgclkR;AACF;AAjc8lR;EAA8D;IAA+B,yBAAA;EAqczrR;AACF;AAtcqtR;EAA+B,sBAAA;EAAsB,WAAA;EAAW,cAAA;EAAc,OAAA;EAAO,gBAAA;EAAgB,WAAA;EAAW,kBAAA;EAAkB,QAAA;EAAQ,sCAAA;EAAoC,2BAAA;EAA2B,mBAAA;EAAmB,WAAA;AAodj7R;;AApd47R;EAAyB;IAA+B,gBAAA;IAAe,kBAAA;EA0djgS;AACF;AA3dqhS;EAAqB,8BAAA;EAA0B,WAAA;EAAW,cAAA;EAAc,kBAAA;EAAkB,kBAAA;EAAkB,QAAA;EAAQ,MAAA;EAAM,UAAA;AAqe/oS;;AAreypS;EAAyB;IAAqB,gBAAA;IAAe,iBAAA;EA2eptS;AACF","sourcesContent":[".image-gallery-icon{color:#fff;transition:all .3s ease-out;appearance:none;background-color:rgba(0,0,0,0);border:0;cursor:pointer;outline:none;position:absolute;z-index:4;filter:drop-shadow(0 2px 2px rgb(25.5, 25.5, 25.5))}@media(hover: hover)and (pointer: fine){.image-gallery-icon:hover{color:#337ab7}.image-gallery-icon:hover .image-gallery-svg{transform:scale(1.1)}}.image-gallery-icon:focus{outline:2px solid #337ab7}.image-gallery-using-mouse .image-gallery-icon:focus{outline:none}.image-gallery-fullscreen-button,.image-gallery-play-button{bottom:0;padding:20px}.image-gallery-fullscreen-button .image-gallery-svg,.image-gallery-play-button .image-gallery-svg{height:28px;width:28px}@media(max-width: 768px){.image-gallery-fullscreen-button,.image-gallery-play-button{padding:15px}.image-gallery-fullscreen-button .image-gallery-svg,.image-gallery-play-button .image-gallery-svg{height:24px;width:24px}}@media(max-width: 480px){.image-gallery-fullscreen-button,.image-gallery-play-button{padding:10px}.image-gallery-fullscreen-button .image-gallery-svg,.image-gallery-play-button .image-gallery-svg{height:16px;width:16px}}.image-gallery-fullscreen-button{right:0}.image-gallery-play-button{left:0}.image-gallery-top-nav,.image-gallery-bottom-nav{padding:10px 10px;left:50%;transform:translateX(-50%)}.image-gallery-top-nav .image-gallery-svg,.image-gallery-bottom-nav .image-gallery-svg{height:120px;width:90px}@media(max-width: 768px){.image-gallery-top-nav .image-gallery-svg,.image-gallery-bottom-nav .image-gallery-svg{height:72px;width:48px}}@media(max-width: 480px){.image-gallery-top-nav .image-gallery-svg,.image-gallery-bottom-nav .image-gallery-svg{height:48px;width:36px}}.image-gallery-top-nav[disabled],.image-gallery-bottom-nav[disabled]{cursor:disabled;opacity:.6;pointer-events:none}.image-gallery-top-nav{top:0}.image-gallery-bottom-nav{bottom:0}.image-gallery-left-nav,.image-gallery-right-nav{padding:50px 10px;top:50%;transform:translateY(-50%)}.image-gallery-left-nav .image-gallery-svg,.image-gallery-right-nav .image-gallery-svg{height:120px;width:60px}@media(max-width: 768px){.image-gallery-left-nav .image-gallery-svg,.image-gallery-right-nav .image-gallery-svg{height:72px;width:36px}}@media(max-width: 480px){.image-gallery-left-nav .image-gallery-svg,.image-gallery-right-nav .image-gallery-svg{height:48px;width:24px}}.image-gallery-left-nav[disabled],.image-gallery-right-nav[disabled]{cursor:disabled;opacity:.6;pointer-events:none}.image-gallery-left-nav{left:0}.image-gallery-right-nav{right:0}.image-gallery{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);position:relative}.image-gallery.fullscreen-modal{background:#000;bottom:0;height:100%;left:0;position:fixed;right:0;top:0;width:100%;z-index:5}.image-gallery.fullscreen-modal .image-gallery-content{top:50%;transform:translateY(-50%)}.image-gallery-content{position:relative;line-height:0;top:0}.image-gallery-content.fullscreen{background:#000}.image-gallery-content .image-gallery-slide .image-gallery-image{max-height:calc(100vh - 80px)}.image-gallery-content.image-gallery-thumbnails-left .image-gallery-slide .image-gallery-image,.image-gallery-content.image-gallery-thumbnails-right .image-gallery-slide .image-gallery-image{max-height:100vh}.image-gallery-slide-wrapper{position:relative}.image-gallery-slide-wrapper.image-gallery-thumbnails-left,.image-gallery-slide-wrapper.image-gallery-thumbnails-right{display:inline-block;width:calc(100% - 110px)}@media(max-width: 768px){.image-gallery-slide-wrapper.image-gallery-thumbnails-left,.image-gallery-slide-wrapper.image-gallery-thumbnails-right{width:calc(100% - 87px)}}.image-gallery-slide-wrapper.image-gallery-rtl{direction:rtl}.image-gallery-slides{line-height:0;overflow:hidden;position:relative;white-space:nowrap;text-align:center;touch-action:none}.image-gallery-slide{left:0;position:absolute;top:0;width:100%}.image-gallery-slide.image-gallery-center{position:relative}.image-gallery-slide .image-gallery-image{width:100%;object-fit:contain}.image-gallery-slide .image-gallery-description{background:rgba(0,0,0,.4);bottom:70px;color:#fff;left:0;line-height:1;padding:10px 20px;position:absolute;white-space:normal}@media(max-width: 768px){.image-gallery-slide .image-gallery-description{bottom:45px;font-size:.8em;padding:8px 15px}}.image-gallery-bullets{bottom:20px;left:0;margin:0 auto;position:absolute;right:0;width:80%;z-index:4}.image-gallery-bullets .image-gallery-bullets-container{margin:0;padding:0;text-align:center}.image-gallery-bullets .image-gallery-bullet{appearance:none;background-color:rgba(0,0,0,0);border:1px solid #fff;border-radius:50%;box-shadow:0 2px 2px hsl(0,0%,10%);cursor:pointer;display:inline-block;margin:0 5px;outline:none;padding:5px;transition:all .2s ease-out}@media(max-width: 768px){.image-gallery-bullets .image-gallery-bullet{margin:0 3px;padding:3px}}@media(max-width: 480px){.image-gallery-bullets .image-gallery-bullet{padding:2.7px}}.image-gallery-bullets .image-gallery-bullet:focus{transform:scale(1.2);background:#337ab7;border:1px solid #337ab7}.image-gallery-bullets .image-gallery-bullet.active{transform:scale(1.2);border:1px solid #fff;background:#fff}@media(hover: hover)and (pointer: fine){.image-gallery-bullets .image-gallery-bullet:hover{background:#337ab7;border:1px solid #337ab7}.image-gallery-bullets .image-gallery-bullet.active:hover{background:#337ab7}}.image-gallery-bullets.image-gallery-bullets-vertical{left:20px;right:auto;bottom:auto;width:auto;top:50%;transform:translateY(-50%)}.image-gallery-bullets.image-gallery-bullets-vertical .image-gallery-bullet{display:block;margin:12px 0}@media(max-width: 768px){.image-gallery-bullets.image-gallery-bullets-vertical .image-gallery-bullet{margin:6px 0px;padding:3px}}@media(max-width: 480px){.image-gallery-bullets.image-gallery-bullets-vertical .image-gallery-bullet{padding:2.7px}}.image-gallery-thumbnails-wrapper{position:relative}.image-gallery-thumbnails-wrapper.thumbnails-swipe-horizontal{touch-action:pan-y}.image-gallery-thumbnails-wrapper.thumbnails-swipe-vertical{touch-action:pan-x}.image-gallery-thumbnails-wrapper.thumbnails-wrapper-rtl{direction:rtl}.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left,.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right{display:inline-block;vertical-align:top;width:100px}@media(max-width: 768px){.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left,.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right{width:81px}}.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails,.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails{height:100%;width:100%;left:0;padding:0;position:absolute;top:0}.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail,.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail{display:block;margin-right:0;padding:0}.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left .image-gallery-thumbnails .image-gallery-thumbnail+.image-gallery-thumbnail,.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right .image-gallery-thumbnails .image-gallery-thumbnail+.image-gallery-thumbnail{margin-left:0;margin-top:2px}.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left,.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right{margin:0 5px}@media(max-width: 768px){.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-left,.image-gallery-thumbnails-wrapper.image-gallery-thumbnails-right{margin:0 3px}}.image-gallery-thumbnails{overflow:hidden;padding:5px 0}@media(max-width: 768px){.image-gallery-thumbnails{padding:3px 0}}.image-gallery-thumbnails .image-gallery-thumbnails-container{cursor:pointer;text-align:center;white-space:nowrap}.image-gallery-thumbnail{display:inline-block;border:4px solid rgba(0,0,0,0);transition:border .3s ease-out;width:100px;background:rgba(0,0,0,0);padding:0}@media(max-width: 768px){.image-gallery-thumbnail{border:3px solid rgba(0,0,0,0);width:81px}}.image-gallery-thumbnail+.image-gallery-thumbnail{margin-left:2px}.image-gallery-thumbnail .image-gallery-thumbnail-inner{display:block;position:relative}.image-gallery-thumbnail .image-gallery-thumbnail-image{vertical-align:middle;width:100%;line-height:0}.image-gallery-thumbnail.active,.image-gallery-thumbnail:focus{outline:none;border:4px solid #337ab7}@media(max-width: 768px){.image-gallery-thumbnail.active,.image-gallery-thumbnail:focus{border:3px solid #337ab7}}@media(hover: hover)and (pointer: fine){.image-gallery-thumbnail:hover{outline:none;border:4px solid #337ab7}}@media(hover: hover)and (pointer: fine)and (max-width: 768px){.image-gallery-thumbnail:hover{border:3px solid #337ab7}}.image-gallery-thumbnail-label{box-sizing:border-box;color:#fff;font-size:1em;left:0;line-height:1em;padding:5%;position:absolute;top:50%;text-shadow:0 2px 2px hsl(0,0%,10%);transform:translateY(-50%);white-space:normal;width:100%}@media(max-width: 768px){.image-gallery-thumbnail-label{font-size:.8em;line-height:.8em}}.image-gallery-index{background:rgba(0,0,0,.4);color:#fff;line-height:1;padding:10px 20px;position:absolute;right:0;top:0;z-index:4}@media(max-width: 768px){.image-gallery-index{font-size:.8em;padding:5px 10px}}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
